import {
  ThemeProvider as UiThemeProvider,
  type ThemeMode,
} from "@iluvatar/ui-kit";
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
} from "react";

type ThemeContextType = {
  setTheme: Dispatch<SetStateAction<ThemeMode>>;
  theme: ThemeMode;
};
export const ThemeContext = createContext<ThemeContextType>({
  setTheme: () => null,
  theme: "light",
});
export function ThemeProvider({
  children,
  initialValues,
}: PropsWithChildren<{ initialValues: { theme: ThemeMode } }>) {
  const [theme, setTheme] = useState(initialValues.theme);
  useEffect(() => {
    document.documentElement.classList.toggle("dark-theme", theme === "dark");
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.dataset.uiTheme = theme;
    try {
      localStorage.setItem("theme", theme);
    } catch {
      /* Storage may be unavailable. */
    }
  }, [theme]);
  const context = useMemo(() => ({ theme, setTheme }), [theme]);
  return (
    <ThemeContext.Provider value={context}>
      <UiThemeProvider theme={theme} className="h-full min-h-0">
        {children}
      </UiThemeProvider>
    </ThemeContext.Provider>
  );
}
export const useThemeContext = (): ThemeContextType => useContext(ThemeContext);
